"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var admin_student_pay_fee_controller_1 = __importDefault(require("./admin-student-pay-fee.controller"));
var admin_student_pay_fee_html_1 = __importDefault(require("./admin-student-pay-fee.html"));
function getFee($stateParams, FeeModel) {
    return FeeModel.getFee($stateParams.feeId)
        .then(function (response) {
        return response;
    })
        .catch(function (Error) {
        console.error(Error);
    });
}
getFee.$inject = ["$stateParams", "UsersModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.students.view.fees.pay", {
        url: "/:feeId/pay-fee",
        controller: admin_student_pay_fee_controller_1.default,
        controllerAs: "vm",
        template: admin_student_pay_fee_html_1.default,
        resolve: {
            fee: function () { },
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.dashboard.students.view.fees.pay", [])
    .config(config)
    .controller("AdminStudentViewFeesPayController", admin_student_pay_fee_controller_1.default);
